var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIssue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.05 6.82C13.1825 6.82 14.2686 7.26987 15.0694 8.07065C15.8702 8.87143 16.32 9.95753 16.32 11.09V14.82C16.32 15.9525 15.8702 17.0386 15.0694 17.8393C14.2686 18.6401 13.1825 19.09 12.05 19.09C10.9176 19.09 9.83146 18.6401 9.03068 17.8393C8.2299 17.0386 7.78003 15.9525 7.78003 14.82V11.09C7.78003 9.95753 8.2299 8.87143 9.03068 8.07065C9.83146 7.26987 10.9176 6.82 12.05 6.82ZM12.05 4.82C10.3887 4.82527 8.79701 5.48755 7.6223 6.66227C6.44758 7.83698 5.7853 9.42871 5.78003 11.09V14.82C5.78003 16.4829 6.44062 18.0777 7.61647 19.2536C8.79232 20.4294 10.3871 21.09 12.05 21.09C13.7129 21.09 15.3077 20.4294 16.4836 19.2536C17.6594 18.0777 18.32 16.4829 18.32 14.82V11.09C18.3148 9.42871 17.6525 7.83698 16.4778 6.66227C15.3031 5.48755 13.7113 4.82527 12.05 4.82Z",
    fill: "#18406E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16211 2.30965L6.78717 3.76208L10.244 7.03442L11.6189 5.58199L8.16211 2.30965Z",
    fill: "#18406E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8798 2.31406L13.4236 5.58701L14.7988 7.0392L18.255 3.76625L16.8798 2.31406Z",
    fill: "#18406E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 7.7H16.81V9.7H20.5V7.7Z",
    fill: "#18406E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.32 9.9H10.78V11.9H13.32V9.9Z",
    fill: "#18406E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.32 13.98H10.78V15.98H13.32V13.98Z",
    fill: "#18406E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.29002 7.7H3.58002V9.7H7.29002V7.7Z",
    fill: "#18406E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 16.17H16.81V18.17H20.5V16.17Z",
    fill: "#18406E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.29002 16.17H3.58002V18.17H7.29002V16.17Z",
    fill: "#18406E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.78002 11.95H3.58002V13.95H5.78002V11.95Z",
    fill: "#18406E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.52 11.95H18.32V13.95H20.52V11.95Z",
    fill: "#18406E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_446"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssue);
export default __webpack_public_path__ + "static/media/issue.7efc07fd49b1149099ed2a8a15e41343.svg";
export { ForwardRef as ReactComponent };